var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.3
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82255 3H15.3123C16.8712 3 18.1349 4.26377 18.1349 5.82255V12.2688C17.7895 12.532 17.5183 12.6523 17.2399 12.6481C16.9608 12.6439 16.67 12.5148 16.2857 12.2679V11.492H11.492V16.2857H12.8672C13.069 16.6904 13.1539 16.9902 13.1465 17.2691C13.1392 17.5474 13.0404 17.8081 12.8682 18.1349H5.82255C4.26377 18.1349 3 16.8712 3 15.3123V5.82255C3 4.26377 4.26377 3 5.82255 3ZM4.84918 15.3123C4.84918 15.85 5.2849 16.2857 5.82255 16.2857H9.64286V11.492H4.84918V15.3123ZM5.82255 4.84918C5.2849 4.84918 4.84918 5.2849 4.84918 5.82255V9.64286H9.64286V4.84918H5.82255ZM11.492 9.64286H16.2857V5.82255C16.2857 5.2849 15.85 4.84918 15.3123 4.84918H11.492V9.64286Z",
    fill: "#10A37F",
    stroke: "#F5F5F5",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2422 18.7913V20.9933C18.2422 21.4341 18.5995 21.7913 19.0402 21.7913C19.4807 21.7911 19.8371 21.4338 19.8371 20.9933V18.7913H22.0402C22.4807 18.7911 22.8371 18.4338 22.8371 17.9933C22.8371 17.5528 22.4807 17.1956 22.0402 17.1953H19.8371V14.9933C19.8371 14.5528 19.4807 14.1956 19.0402 14.1953C18.5995 14.1953 18.2422 14.5526 18.2422 14.9933V17.1953H16.0402C15.5995 17.1953 15.2422 17.5526 15.2422 17.9933C15.2422 18.4341 15.5995 18.7913 16.0402 18.7913H18.2422Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddTable);
export default __webpack_public_path__ + "static/media/icon-add-table.dd32752f3984f9ec5c4a32ab050ef58b.svg";
export { ForwardRef as ReactComponent };